import React from 'react'
import PropTypes from 'prop-types'
import { locationShape } from 'react-router'

import EventDetailPage from './event/EventDetail/EventDetailPage/EventDetailPage'
import EventChat from './event/EventDetail/EventChat/EventChat'
import GuestListsPage from './event/EventDetail/GuestsListPage/GuestsListPage'
import MediaPage from 'src/containers/MediaPage'
import OrdersPage from './OrdersPage'
import OrderDetailPage from './OrderDetailPage'
import RequestRefundPage from './RequestRefundPage'
import AddGuestsPage from './event/EventDetail/AddGuestsPage/AddGuestsPageContainer'
import OpenInAppModal from 'src/components/OpenInAppModal'

export default class EventSections extends React.Component {
  _routerActiveKey() {
    const { tabRoutes } = this.props
    let route = this.props.location.pathname
    if (route) {
      const routeMatch = route.match(/\//g)
      if (routeMatch && routeMatch.length > 1 && !route.endsWith('/')) {
        history.pushState({}, '', route + '/')
      }
    }
    if (route.startsWith('/')) {
      route = route.substr(1)
    }
    if (route === '') {
      route = 'details'
    }

    if (tabRoutes.indexOf(route) === -1) {
      return 'details'
    } else {
      return route
    }
  }

  _getCurComponent() {
    // const activeKey = this._routerActiveKey()
    const { onChangeEventModal, eventModal } = this.props
    const components = {
      details: <EventDetailPage onChange={onChangeEventModal} />,
      guests: <GuestListsPage />,
      media: <MediaPage />,
      comments: <EventChat />,
      orders: <OrdersPage />,
      orderDetail: <OrderDetailPage />,
      requestRefund: <RequestRefundPage />,
      addGuests: <AddGuestsPage />
    }
    let curComponent = components[eventModal]

    return curComponent || components['details']
  }

  render() {
    return (
      <div style={{ height: '100%', overflow: 'hidden' }}>
        {this._getCurComponent()}
        <OpenInAppModal event={this.props.event} />
      </div>
    )
  }
}

EventSections.propTypes = {
  onChangeEventModal: PropTypes.func.isRequired,
  tabRoutes: PropTypes.array,
  location: locationShape,
  event: PropTypes.object,
  eventModal: PropTypes.string
}
